import useClickOutside from "../../hooks/useClickOutside";
import styles from "./DropdownList.module.css";
import ArrowDown from "../../components/icons/ArrowDown";

interface IProps {
    dropdownFor?: string,
    customClassName?: string,
    data: any [], 
    nameKey: string, 
    selectedValue: string | number, 
    clickHandler: (item: any, args?: { [key: string]: string }) => void,
    clickHandlerArgs?: { [key: string]: string }
}


const DropdownList: React.FC<IProps> = (props) => {

    const { 
        dropdownFor = "",
        customClassName = "",
        data, 
        nameKey, 
        selectedValue, 
        clickHandler, 
        clickHandlerArgs 
    } = props;

    const { elementRef, isVisible, setIsVisible } = useClickOutside({ exceptions: [] });
    const toggleDropdown = () => setIsVisible(!isVisible);


    return (
        <div className = {`${styles.dropdown_list} ${styles[customClassName]}`} >
            <div 
                className = {styles.hidden_div}
                ref = {elementRef}
                onClick = {toggleDropdown}
            >
            </div>
            <p>{dropdownFor === "View" ? `Show ${selectedValue}` : selectedValue}</p>
            <ArrowDown />
            <div 
                className={styles.dropdown_item_list} 
                style={{ display: isVisible ? "block" : "none" }}
            >
                <ul>
                    {data.map(item => {
                        return (
                            <li 
                                key = {item._id} 
                                onClick = {() => clickHandler(item, clickHandlerArgs)}
                            >
                                {item[nameKey]}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );

}


export default DropdownList;